var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinbaseWalletApi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 188,
    viewBox: "0 0 357 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5543_42683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 16C0.666748 7.16344 7.83019 0 16.6667 0H340.667C349.503 0 356.667 7.16344 356.667 16V172C356.667 180.837 349.503 188 340.667 188H16.6667C7.83019 188 0.666748 180.837 0.666748 172V16Z",
    fill: "#73A2FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5543_42683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299 34H291V42H299V34Z",
    fill: "#CED2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 146H291V154H299V146Z",
    fill: "#CED2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 50H127V138H235V50Z",
    fill: "#CED2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8 138C204.101 138 223.8 118.301 223.8 94C223.8 69.6995 204.101 50 179.8 50C155.5 50 135.8 69.6995 135.8 94C135.8 118.301 155.5 138 179.8 138Z",
    fill: "#00D17F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.6 138C256.901 138 276.6 118.301 276.6 94C276.6 69.6995 256.901 50 232.6 50C208.3 50 188.6 69.6995 188.6 94C188.6 118.301 208.3 138 232.6 138Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 138C151.301 138 171 118.301 171 94C171 69.6995 151.301 50 127 50C102.7 50 83.0002 69.6995 83.0002 94C83.0002 118.301 102.7 138 127 138Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 58.8C146.4 58.8 162.2 74.6 162.2 94C162.2 113.4 146.4 129.2 127 129.2C107.6 129.2 91.8003 113.4 91.8003 94C91.8003 74.6 107.6 58.8 127 58.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2 94C157.2 77.3 143.7 63.8 127 63.8C110.3 63.8 96.8003 77.3 96.8003 94C96.8003 110.7 110.3 124.2 127 124.2C143.7 124.2 157.2 110.7 157.2 94Z",
    fill: "#8E76FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1 72.3V88.3L139.3 94.4L126.1 72.3Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1 72.3L112.9 94.4L126.1 88.3V72.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1 104.8V115.7L139.3 96.9L126.1 104.8Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1 115.7V104.8L112.9 96.9L126.1 115.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1 102.3L139.3 94.4L126.1 88.3V102.3Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9 94.4L126.1 102.3V88.4L112.9 94.4Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.2 58.8C216.9 66.8 223.8 79.6 223.8 94C223.8 108.4 216.9 121.2 206.2 129.2C195.5 121.2 188.6 108.4 188.6 94C188.6 79.6 195.5 66.8 206.2 58.8Z",
    fill: "#0A0B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.402 94C241.402 108.4 248.302 121.2 259.002 129.2C269.702 121.2 276.602 108.4 276.602 94C276.602 79.6 269.702 66.8 259.002 58.8C248.302 66.8 241.402 79.6 241.402 94Z",
    fill: "#5DE2F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0002 34H59.0002V42H67.0002V34Z",
    fill: "#CED2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0002 146H59.0002V154H67.0002V146Z",
    fill: "#CED2DB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5543_42683"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 16C0.666748 7.16344 7.83019 0 16.6667 0H340.667C349.503 0 356.667 7.16344 356.667 16V172C356.667 180.837 349.503 188 340.667 188H16.6667C7.83019 188 0.666748 180.837 0.666748 172V16Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5543_42683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 120,
    fill: "white",
    transform: "translate(59.0002 34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbaseWalletApi);
export default __webpack_public_path__ + "static/media/CoinbaseWalletApi.cba5b50b3a98c551b652c777c31cb87d.svg";
export { ForwardRef as ReactComponent };